import React, { useEffect, useRef, useState } from "react";
import FormModal from "../FlightEnquiryForm/FormModal";
import { AirportSelector } from "../FlightEnquiryForm/AirportSelector";
import DatePicker from "react-date-picker";
import moment from "moment";
import { IFlightEnquiry } from "../types/flights";
import { toast } from "react-toastify";
import { appAxios } from "../../axios/axios";
import CreateNewAgent from "../FlightEnquiryForm/CreateNewAgent";
import ReCaptcha from "../Common/Ui/ReCaptcha";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { LoadingButton } from "../Common/Ui/LoadingButton";
import { CustomInput } from "../Common/Ui/CustomInput";
import { AdultChildDetails } from "../Common/AdultChildDetails";
import { useLocation, useNavigate } from "react-router-dom";
const CustomCkEditor = React.lazy(() => import("../Common/Ui/CustomCkEditor"));

const FlightsForm: React.FC<{
  onSaveEnquiry?: any;
  onBehalfByStaff?: boolean;
  userData?: any;
}> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const flightData: IFlightEnquiry = location?.state?.enquiryData;
  const enquiryId: number = location?.state?.enquiryId;
  const isUpdating = flightData ? true : false;
  const [show, setShow] = useState(false);
  const [handleModalClose, setHandleModalClose] = useState(false);
  const userModalHandleClose = () => setHandleModalClose(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [flightQuery, updateFlightQuery] = useState<IFlightEnquiry>(
    flightData || {
      remark: "",
      passengers: [],
      segments: [],
      type: "Flight Enquiry",
      noOfAdult: 1,
      noOfChild: 0,
      noOfInfant: 0,
    }
  );

  // const [captchaToken, setCaptchaToken] = useState<string | undefined>(
  //   undefined
  // );
  // const reCaptchaRef = useRef<any>();
  const isLoogedIn = getAuthToken();

  const [passengerPopup, setPassengerPopup] = useState(false);

  const insertSegment = () => {
    if (flightQuery.segments && flightQuery.segments?.length >= 5) {
      return;
    }
    updateFlightQuery((old) => {
      old.segments &&
        old.segments.push({
          origin: "",
          destination: "",
          departureDate: moment().format("YYYY-MM-DD"),
          isFlexible: false,
          flightNumber: null,
        });
      return { ...old };
    });
  };

  const saveEnquiry = async () => {
    if (!isLoogedIn) {
      // create usere popup
      return setHandleModalClose(true);
    }

    setRequestLoading(true);
    try {
      const url = "/query/saveFlightEnquiry";
      const dataToBeSend = props.onBehalfByStaff
        ? {
            enquiryData: flightQuery,
            userData: props.userData && props.userData,
            isOnBehalf: props.onBehalfByStaff,
          }
        : {
            enquiryData: flightQuery,
          };
      const saveResponse = await appAxios(url, {
        method: "POST",
        data: dataToBeSend,
        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
      });

      if (saveResponse.data.success) {
        props.onSaveEnquiry && props.onSaveEnquiry();
        updateFlightQuery({
          remark: "",
          passengers: [],
          segments: [
            {
              origin: "",
              destination: "",
              departureDate: moment().format("DD-MM-YYYY"),
              isFlexible: false,
              flightNumber: null,
            },
          ],
          type: "Flight Enquiry",
        });
        toast.success("Enquiry saved successfully");
      }
    } catch (error: any) {
      const errorMessage = "Unable to save enquiry!!";
      toast.error(errorMessage);
    } finally {
      setRequestLoading(false);
    }
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  const updateEnquiry = async () => {
    // let token;
    // if (!captchaToken) {
    //   token = await reCaptchaRef.current.executeAsync();
    //   setCaptchaToken(token);
    // }
    // if (!captchaToken && !token) {
    //   return toast.error("Please solve captcha");
    // }
    setRequestLoading(true);
    try {
      const updateResponse = await appAxios("/query/updateEnquiry", {
        method: "POST",
        // headers: {
        //   "captcha-token": captchaToken ? captchaToken : token,
        // },
        data: {
          enquiryData: {
            id: enquiryId,
            ...flightQuery,
          },
        },
      });
      if (updateResponse.data.success) {
        toast.success("Enquiry updated successfully");
        navigate(`/enquiry/${enquiryId}`, {
          replace: true,
        });
      }
    } catch (error) {
      const errorMessage = "Unable to update enquiry!!";
      toast.error(errorMessage);
    }
    setRequestLoading(false);
    // reCaptchaRef.current.reset();
    // setCaptchaToken(undefined);
  };

  const removeSegment = (index) => {
    updateFlightQuery((old) => {
      if (old.segments && old.segments.length > 1) {
        old.segments.splice(index, 1);
      }
      return {
        ...old,
      };
    });
  };

  const validateFlightEnquiry = () => {
    if (!flightQuery.remark || flightQuery.remark.trim().length === 0) {
      return toast.error("Please enter remark");
    }

    for (let index in flightQuery.segments) {
      const segment = flightQuery.segments[index];

      if (!segment.origin || !segment.destination) {
        return toast.error(
          `Please provide origin and destination for segment number ${
            parseInt(index) + 1
          }`
        );
      }
      if (!segment.departureDate) {
        return toast.error(
          `Please provide departure date for segment number ${
            parseInt(index) + 1
          }`
        );
      }

      // check if origin = departuer
      if (segment.origin === segment.destination) {
        return toast.error(
          `Origin and destination can not be same for segment number ${
            parseInt(index) + 1
          }`
        );
      }
    }
    isUpdating ? updateEnquiry() : saveEnquiry();
  };

  useEffect(() => {
    if (flightQuery.segments && flightQuery.segments.length < 1) {
      insertSegment();
    }
  }, []);

  return (
    <div>
      <div className="tab-pane active p-4 flight-enquiry-module">
        <div className="row align-items-center">
          <div>
            <div className="module-name d-flex justify-content-between">
              <h3 className="after-heading pb-3">Flight Enquiry</h3>
              <button
                className="btn btn-info btn-sm px-3 py-1 rounded h-25 text-start"
                onClick={() => setShow(true)}
                type="button"
              >
                Add Pax
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            {flightQuery.segments &&
              flightQuery.segments.map((seg, index) => (
                <div key={index}>
                  <div className="row mb-2">
                    <div className="col-lg-3 small">
                      <AirportSelector
                        controlClassName="location-select"
                        className=""
                        label="Origin"
                        value={
                          seg.origin && seg.origin.length !== 0
                            ? seg.origin
                            : undefined
                        }
                        onChange={(val) => {
                          updateFlightQuery((old) => {
                            old.segments && (old.segments[index].origin = val);
                            return { ...old };
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-3 small">
                      <AirportSelector
                        controlClassName="location-select"
                        className=""
                        label="Destination"
                        value={
                          seg.destination && seg.destination.length !== 0
                            ? seg.destination
                            : undefined
                        }
                        onChange={(val) => {
                          updateFlightQuery((old) => {
                            old.segments &&
                              (old.segments[index].destination = val);
                            return { ...old };
                          });
                        }}
                      />
                    </div>
                    <div
                      className="col-lg-3 small"
                      style={{
                        position: "relative",
                      }}
                    >
                      <label>Departure Date</label>
                      <div
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "16px",
                        }}
                      >
                        <label
                          htmlFor={`flexible-date-${index}`}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Flexible
                        </label>
                        <input
                          style={{
                            cursor: "pointer",
                          }}
                          type="checkbox"
                          className="form-check-input ms-2 border-0"
                          id={`flexible-date-${index}`}
                          checked={seg.isFlexible}
                          onChange={(e) => {
                            updateFlightQuery((old) => {
                              old.segments &&
                                (old.segments[index].isFlexible =
                                  e.target.checked);
                              return { ...old };
                            });
                          }}
                        />
                      </div>
                      <div className="text-dark">
                        <DatePicker
                          className={`bg-light w-100 form-control departure-date-${index}`}
                          value={moment(
                            seg.departureDate,
                            "YYYY-MM-DD"
                          ).toDate()}
                          clearIcon={null}
                          onChange={(date) => {
                            updateFlightQuery((old) => {
                              old.segments &&
                                (old.segments[index].departureDate =
                                  moment(date).format("YYYY-MM-DD"));
                              return {
                                ...old,
                              };
                            });
                          }}
                          format="dd-MM-y"
                          minDate={moment().toDate()}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 small">
                      <CustomInput
                        label="Flight No.(optional)"
                        type="text"
                        value={seg.flightNumber || ""}
                        onChange={(e) => {
                          updateFlightQuery((old) => {
                            old.segments[index].flightNumber =
                              e.target.value || null;
                            return { ...old };
                          });
                        }}
                        id={`flightNum-${index}`}
                        placeholder="BA 98"
                      />
                    </div>
                    <div className="col-lg-1 align-self-end text-end">
                      {flightQuery.segments.length > 1 && (
                        <div className="">
                          <button
                            className="btn minus-btn"
                            onClick={() => removeSegment(index)}
                          >
                            Remove
                          </button>
                        </div>
                      )}
                      {index === flightQuery.segments.length - 1 && (
                        <button
                          className="btn plus-btn"
                          type="submit"
                          onClick={insertSegment}
                        >
                          + Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="row">
          {/* remark */}
          <div className="mb-3 col-lg-6">
            <label>Remark</label>
            <CustomCkEditor
              data={flightQuery.remark}
              onChange={(data) => {
                updateFlightQuery((old: IFlightEnquiry) => {
                  old.remark = data;
                  return { ...old };
                });
              }}
            />
          </div>
          <div className="col-lg-3 mb-3 small">
            <AdultChildDetails
              label="Passenger Details"
              onOpen={() => {
                setPassengerPopup(true);
              }}
              onClose={() => {
                setPassengerPopup(false);
              }}
              onSave={(paxInfo) => {
                updateFlightQuery((old) => {
                  old.noOfAdult = paxInfo.adult;
                  old.noOfChild = paxInfo.child;
                  old.noOfInfant = paxInfo.infant;
                  return { ...old };
                });
                setPassengerPopup(false);
              }}
              paxInfo={{
                adult: flightQuery.noOfAdult || 1,
                child: flightQuery.noOfChild || 0,
                infant: flightQuery.noOfInfant || 0,
              }}
              show={passengerPopup}
            />
          </div>

          {/* captcha */}
          {/* Now captcha will not be shown to logged in user */}
          {/* <div className="col-lg-3 align-self-end">
            {!isLoogedIn && (
              <ReCaptcha
                setToken={(token: string) => {
                  setCaptchaToken(token);
                }}
                myRef={reCaptchaRef}
              />
            )}
          </div> */}
        </div>

        <div>
          <LoadingButton
            loading={requestLoading}
            onClick={validateFlightEnquiry}
          >
            {isUpdating ? "Update " : "Save "}Enquiry
          </LoadingButton>
        </div>

        {/* form popup */}
        {show && (
          <FormModal
            show={show}
            handleClose={() => setShow(false)}
            passengers={[...flightQuery.passengers]}
            saveHandler={(passengers) => {
              updateFlightQuery((old) => {
                old.passengers = passengers;
                return { ...old };
              });
              setShow(false);
              toast.success("Passenger details saved successfully");
            }}
          />
        )}

        {/* form popup end */}
        {/* ------------------------------ User Data Model ---------------------------- */}
        <CreateNewAgent
          handleModalClose={userModalHandleClose}
          isModalOpen={handleModalClose}
          url="/query/saveFlightEnquiry"
          queryData={flightQuery}
          changeQueryData={() => {
            updateFlightQuery({
              remark: "",
              passengers: [],
              segments: [
                {
                  origin: "",
                  destination: "",
                  departureDate: moment().format("DD-MM-YYYY"),
                  flightNumber: null,
                },
              ],
              type: "Flight Enquiry",
            });
          }}
        />
      </div>
    </div>
  );
};

export default FlightsForm;
